import { StorageOfUniqueModels } from '@qality/common-service';

import User, { IDENTIFIER } from './User';

export default {
  init() {
    StorageOfUniqueModels.add('User', User);
    StorageOfUniqueModels.add('IDENTIFIER', IDENTIFIER);
  },
};
